import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from 'react-router-dom';
import { Link } from "react-router-dom";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDButton from "common/components/MD/MDButton";

import MDTypography from "common/components/MD/MDTypography";


// Material Dashboard 2 React example components
import DashboardLayout from "layouts/DashboardLayout";
import DashboardNavbar from "layouts/components/Navbars/DashboardNavbar";
import Footer from "layouts/components/Footer";
import HeaderForm from "layouts/components/HeaderForm";


import Alert from '@mui/material/Alert';



import loading_image from 'common/assets/images/icons/loading-green-loading.gif'
// Data
import ExpoRichiesteService from "services/API/ExpoRichieste/ExpoRichiesteService";


import { Chip, Tooltip } from "@mui/material";
import ExpoRichiesteTable from "./ExpoRichiesteTable";
import { ColumnFilter } from "common/components/implemented/Tables/DataTable/ColumnFilter";

import { SelectColumnFilterTipo } from "./SelectColumnFilterTipo";
import {NoneFilter } from "./NoneFilter";

import { SelectColumnFilterStatoOK } from "./SelectColumnFilterStatoOK";
import { SelectColumnFilterAR } from "./SelectColumnFilterAR";
import { SelectColumnFilterMsg } from "./SelectColumnFilterMsg";

import { useFarFieraUIController } from "common/context/FarFieraContext";
import ExpoRichiesteOKMenu from "common/components/implemented/Menu/ExpoRichiesteOKMenu";
import KeyIcon from '@mui/icons-material/Key';
import KeyOffIcon from '@mui/icons-material/KeyOff';



function ElencoRichieste() {

  const [proposte, setProposte] = useState([]);
  const [ffcontroller] = useFarFieraUIController();
  const { manifestazione } = ffcontroller;


  const [loading, setLoading] = useState(true);


  //per passarmi la variabiule se ho salvato e far comparire l'alert
  const location = useLocation();
  const { state } = location != null ? location : { state: { submitted: false, salvato: 'NO', indietro: false } }; // Read values passed on state




  useEffect(() => {

    //  console.log("FILTRO");
    setProposte([]);
    setLoading(true);

  filtra();

  }, [manifestazione]);

function filtra(){

    ExpoRichiesteService.getAllRichieste(manifestazione, 'INVIATA', 'OK')
      .then(response => {
        setProposte(response.data);
        setLoading(false);
      })
      .catch(e => {
        console.log(e);
        setLoading(false);
      });

}

  const ppAttributes = [];

  if (proposte.length > 0) {
    proposte.forEach(prop => {
      let action2 = (<ExpoRichiesteOKMenu proposta={prop} filtra={filtra}></ExpoRichiesteOKMenu>);


      let msg_a = "DA SCRIVERE";
      if (prop.id_messaggio != null && prop.id_messaggio != 0) {
        msg_a = "DA INVIARE";
        if (prop.inviato) {
          msg_a = "INVIATO IL " + prop.string_data_invio;
        }
      }




      let part = "NO";

      let num_prot= prop.protocollo;
if(prop.avi){
  num_prot=prop.protocollo+"A";
}

      //console.log("ID_PARTECIPAZIONE="+prop.id_partecipazione);


      ppAttributes.push({
        er: prop,
        mqr: prop.mqr,
        protocollo:num_prot,
        azienda: prop.ragione_sociale,
        data_invio: prop.string_data_agg,
        data_um: prop.string_data_agg_accettazione,
        note: prop.note,
        cm_string: prop.cm_string,
        stato: prop.stato_accettazione,
        av: prop.anticipo_controllato_string,
        etichetta: prop.etichetta,
        color: prop.color,
        action: action2,
        esigenze_espositive: prop.esigenze_espositive,
        tipologia_espositiva_string: prop.tipologia_stand,
        msg_a: msg_a,
        id_partecipazione: prop.id_partecipazione,

      })
    });
  }


  // Usa useMemo per stabilizzare ppTableData
  const ppTableData = useMemo(() => (
    ppAttributes), [ppAttributes]); // ← Dipende solo dai dati, non da tutto l'oggetto manifestazione
  const ppcolumns = [
    { Header: "Prot. ", accessor: "protocollo", Filter: ColumnFilter, width: "2%", align: "left", id: "proposte_ok_0" },
    { Header: "Azioni", accessor: "action", Filter: NoneFilter, align: "center", width: "5%", enableGlobalFilter: false, id: "proposte_ok_1", disableSortBy: true },
    { Header: "Azienda", accessor: "azienda", Filter: ColumnFilter, align: "left", with: "20%", id: "proposte_ok_2" },
    { Header: "Codice Merceologico", accessor: "cm_string", Filter: ColumnFilter, width: "10%", align: "left", id: "proposte_ok_3" },
    {
      Header: "Tipologia Espositiva Rich.", accessor: "tipologia_espositiva_string",
      id: "proposte_ok_4",

      Filter: SelectColumnFilterTipo,
      Cell: ({ row }) => {
        return (
          <MDBox>
            <MDBox> <MDTypography variant="button"
              fontWeight="regular"
              color="text">{row.original.tipologia_espositiva_string}</MDTypography></MDBox>
            {row.original.esigenze_espositive &&
              <MDBox>  <MDTypography variant="button"
                fontWeight="regular"
                color="text">*** {row.original.esigenze_espositive.substring(0, 20)}...</MDTypography> </MDBox>}
            {row.original.note &&
              <MDBox>  <MDTypography variant="button"
                fontWeight="regular"
                color="text">*** {row.original.note.substring(0, 20)}...</MDTypography> </MDBox>}
          </MDBox>

        );
      },
      width: "15%", align: "left"
    },
    { Header: "Mq richiesti", accessor: "mqr", Filter: NoneFilter, align: "left", width: "5%", id: "proposte_ok_7" },
    { Header: "Stato", accessor: "stato", Filter: SelectColumnFilterStatoOK, filter: "exactMatch", align: "left", width: "5%", id: "proposte_ok_5" },
    { Header: "Anticipo Controllato", accessor: "av", Filter: ColumnFilter, align: "left", width: "5%", id: "proposte_ok_6" },
    {
      Header: "Etichetta", accessor: "etichetta", Filter: ColumnFilter,
      Cell: ({ row }) => {
        return (
          <Chip label={row.original.etichetta} color={row.original.color} />

        );
      },
      align: "left", width: "5%", id: "proposte_ok_8"
    },
    {
      Header: "A.R.", accessor: row => (row.id_partecipazione != null && row.id_partecipazione != 0) ? "OK" : "KO", Filter: SelectColumnFilterAR, width: "5%",
      Cell: ({ value }) => {
        return value === "OK" ? (
          <Tooltip title="Area Riservata Abilitata">
            <KeyIcon color="success" />
          </Tooltip>
        ) : (
          <Tooltip title="Area Riservata disabilitata">
            <KeyOffIcon />
          </Tooltip>
        );
      },
      align: "left", id: "proposte_ok_12"
    },
    { Header: "Msg Accettazione", accessor: "msg_a", Filter: SelectColumnFilterMsg, width: "5%", align: "left", id: "proposte_ok_10" },
  ];

  const mypagination = { color: 'success', variant: "contained" };




  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>

          <Grid item xs={12}>
            <Card>
              <HeaderForm titolo="Proposte di Partecipazione Accettate" add="" modo="vis" />
              <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">

                {(state != null && state.submitted && (state.salvato === 'INS' || state.salvato === 'MOD')) &&

                  <Alert severity="success">Dati Proposta salvati con successo!</Alert>}
                {(state != null && state.submitted && (state.salvato === 'SENT')) &&

                  <Alert severity="success">Proposta di partecipazione inviata con successo!</Alert>}
                {(state != null && state.submitted && state.salvato === 'DEL') &&

                  <Alert severity="success">Proposta eliminata con successo!</Alert>}
              </MDBox>


              <MDBox pt={3}>
                <ExpoRichiesteTable canSearch={true}
                  rs={ppTableData}
                  cols={ppcolumns}
                  nome_tabella="proposte_ok"
                  isSorted={true}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  pagination={mypagination}
                  noEndBorder
                  responsive={true}
                  first_load={state == null || !state.indietro}
                  filtro_server={true}
                  canExport={true}
                  canSend={true}
                  enableColumnFilters={true}
                  chiamante='expo_richieste_ok_admin'
                  filtra={filtra}
                />
              </MDBox>
              {loading &&
                <MDBox opacity={1} textAlign="center">
                  <img src={loading_image} alt="loading" width={100} />
                </MDBox>
              }

              {(proposte == null || proposte.length === 0) &&
                <MDBox style={{ height: "200px" }} textAlign='center'>
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    Non ci sono Proposte di partecipazione in archivio. Clicca su Nuovo per crearne una!
                  </MDTypography></MDBox>
              }
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}



export default ElencoRichieste;
